import { render, staticRenderFns } from "./ListPengembalian.vue?vue&type=template&id=2ce4bf60"
import script from "./ListPengembalian.vue?vue&type=script&lang=js"
export * from "./ListPengembalian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports